import React from 'react';
import { Slider } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { convertStyleData } from '@utils/tools';

import './GradeEleCustomComponent.less';

export default function GradeEleCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  const formCompindex = props.formCompindex;    // 动态表单索引
  const form_data = props.form_data || {};      // 动态表单传入数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  /**
   * 组件内容处理
   */   
  let content = data.content;
  const segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 根据customFeature.type字段生成对应内容
   */
  const $content = () => {
    // 组件类型、单项样式、选中颜色
    const { type, icon, selectedBackgroundColor = '#3091f2' } = customFeature;
    // 当前评分
    let editScore = data.editScore;
    let getIconName = (i) => {
      let o = {
        'love': 'heart',
        'plum': 'clubs',
      }
      return o[i] || i;
    }
    if (type == 0) {
      return <div className="grade-wrap">
        {[1,2,3,4,5].map((item, index) => {
          return <div
            key={index}
            className={`ico-moon icon-${getIconName(icon)}${ editScore >= item ? '' : '-empty' }`}
            style={{
              color: editScore >= item ? selectedBackgroundColor : '#D3D3D3'
            }}
            onClick={bindScoreChange}
            data-compindex={props.index}
            data-segment={customFeature.segment}
            data-formcompindex={formCompindex}
            data-datakey={`eles[${formCompindex}].form_data.${customFeature.segment}`}
            data-score={item} 
          ></div>;
          })}
      </div>;
    } else if (type == 1) {
      return <React.Fragment>
        <div className="slider">
          <Slider
            min={0}
            max={ Number(customFeature.numberNodes) || 1 }
            trackStyle={{
              backgroundColor: customFeature.selectedBackgroundColor
            }}
            railStyle={{
              backgroundColor: customFeature.lineBackgroundColor
            }}
            handleStyle={{
              borderColor: customFeature.sliderColor,
              backgroundColor: customFeature.sliderColor
            }}
            onChange={bindSliderChange}
          />
        </div>
        <div className="slider-score">{ data.sliderScore || 0 }</div>
      </React.Fragment>;
    }
  }
  /**
   * 绑定事件
   */
  /**
   * 评分点击更改
   * @param {*} event 
   */
  function bindScoreChange(event) {
    let dataset = event.currentTarget.dataset;
    let pageInstance = app.getAppCurrentPage();
    let datakey = dataset.datakey;
    let value = dataset.score;
    let compindex = dataset.compindex;
    let formcompindex = dataset.formcompindex;
    let segment = dataset.segment;

    if (!segment) {
      app.showModal({
        content: '该组件未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    let newdata = {};
    newdata[datakey] = value;
    newdata['eles[' + formcompindex +'].content[' + compindex + '].editScore'] = value;
    pageInstance.setData(newdata);
  }
  /**
   * 评分滑动更改
   * @param {*} event 
   */
  function bindSliderChange(event) {
    let value = event;
    let pageInstance = app.getAppCurrentPage();
    let datakey = `eles[${formCompindex}].form_data.${customFeature.segment}`;
    let compindex = props.index;
    let formcompindex = formCompindex;
    let segment = customFeature.segment;

    if (!segment) {
      app.showModal({
        content: '该组件【评分】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    let newdata = {};
    newdata[datakey] = value;
    newdata['eles[' + formcompindex +'].content[' + compindex + '].sliderScore'] = value;
    pageInstance.setData(newdata);
  }
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component grade-ele" style={styleObj}>
      {$content()}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/grade-ele-custom-component/GradeEleCustomComponent.jsx